import { AdBanner } from "@/components/ads/AdBanner";
import { Seo } from "@/components/seo/Seo";
import { homepageSeo, seoRoutes, toolJsonLd } from "@/config/seo.config";
import { HomeToolSection } from "@/sections/HomeToolSection";

export function HomePage() {
  return (
    <>
      <Seo
        path={homepageSeo.path}
        title={homepageSeo.title}
        description={homepageSeo.description}
        robots={homepageSeo.robots}
        jsonLd={[toolJsonLd()]}
      />
      <HomeToolSection />
      <AdBanner slot="belowHero" />
      <section className="mx-auto max-w-6xl px-4 pb-14 sm:px-6">
        <div className="border-t border-neutral-200 pt-8 dark:border-neutral-800">
          <h2 className="text-2xl font-semibold">
            Quick ways to use it
          </h2>
          <div className="mt-5 grid gap-3 md:grid-cols-3">
            {seoRoutes.slice(0, 6).map((route) => (
              <a
                key={route.path}
                href={route.path}
                className="border border-neutral-200 p-4 transition hover:border-neutral-950 dark:border-neutral-800 dark:hover:border-white"
              >
                <h3 className="font-medium">{route.label}</h3>
                <p className="mt-2 text-sm leading-6 text-neutral-600 dark:text-neutral-400">
                  {route.description}
                </p>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
